export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/bookedCarsIconBlack.f13e9cae.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};